/* src/app/payroll/third-party/third-party-payroll-container/third-party-payroll-container.component.scss */
body#themeTag :host ::ng-deep .scroll-container {
  overflow: auto;
  height: calc(100vh - 17rem);
}
body#themeTag :host ::ng-deep .p-inline-message {
  width: 100%;
  text-align: left;
  display: inline-block;
}
body#themeTag :host ::ng-deep .p-datatable .p-datatable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header,
body#themeTag :host ::ng-deep .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header,
body#themeTag :host ::ng-deep .tabulator .p-datatable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header,
body#themeTag :host ::ng-deep .tabulator .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header,
body#themeTag :host ::ng-deep .table .p-datatable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header,
body#themeTag :host ::ng-deep .table .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header {
  height: 2.5em;
}
body#themeTag :host ::ng-deep .p-datatable .p-datatable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-footer,
body#themeTag :host ::ng-deep .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-footer,
body#themeTag :host ::ng-deep .tabulator .p-datatable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-footer,
body#themeTag :host ::ng-deep .tabulator .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-footer,
body#themeTag :host ::ng-deep .table .p-datatable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-footer,
body#themeTag :host ::ng-deep .table .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-footer {
  height: 0;
}
/*# sourceMappingURL=third-party-payroll-container.component.css.map */
